 
import {useQuery, gql} from "@apollo/client";
var COMPANY_LOGO = gql`
query CompanyLogo {
    companyLogo(where: {localization: {culture_starts_with: "fa"}}) {
      image {
        urls(first: 1)
      }
    }
  }
`;
export const useCompanyLogo = () => {
  const {error, data, loading} = useQuery(COMPANY_LOGO);
  return {
    error,
    data,
    loading
  }
}